import { z } from 'zod';

import { idSchema } from './id';

export const termsSchema = z.object({
    id: idSchema,
    language: z.string().length(5),
    shortText: z.string(),
    text: z.string(),
    validFrom: z.string(),
});

export type Terms = z.infer<typeof termsSchema>;

export const consentPostRequestSchema = z.object({
    id: idSchema,
    accepted: z.boolean(),
    language: z.string(),
});

export type ConsentPostRequest = z.infer<typeof consentPostRequestSchema>;

export const consentSchema = z.object({
    status: z.enum(['no', 'outdated', 'yes']),
    time: z.string().optional(),
});

export type Consent = z.infer<typeof consentSchema>;
